module.exports = __webpack_public_path__ + "assets/b1dcffbdc69a4156bcb3f797abb31533.png";